import {EventBus} from "../../../../common/ts/events/EventBus";
import eventHandlers from "./eventHandlers";
import {GOOGLE_COOKIES_ENABLED_LOCAL_STORAGE_KEY} from "../cmpAdsManager/constants";
import SaveSearchModal from "../../../../common/ts/components/modals/retention/SaveSearchModal";

function init(device: string, saveSearchModal:SaveSearchModal) {
    eventHandlers.init(EventBus.getInstance(), device, saveSearchModal);
}

export function hasConsentForGoogleCookies() {
    return localStorage.getItem(GOOGLE_COOKIES_ENABLED_LOCAL_STORAGE_KEY);
}

export function hasGoogleOneTapAlreadyBeenPrompted() {
    return document.cookie.indexOf('_showGoogleOneTap') !== -1;
}

export default {
    init,
};
